import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SignupRequest } from '../models/signup';
import { SubscriptionLevel } from '../models/user';

@Injectable()
export class SignupService {
  featureLevel = new BehaviorSubject<SubscriptionLevel>(
    SubscriptionLevel.PREMIUM
  );
  readonly featureLevel$ = this.featureLevel.asObservable();
  constructor(private http: HttpClient) {}
  checkAccountExist(value: string): Observable<{ Exists: boolean }> {
    return this.http.get<any>(
      `${
        environment.pcmilerAppUrl
      }/api/Account/Exists?accountName=${encodeURIComponent(value)}`
    );
  }
  checkExistUser(value: string): Observable<{ Exists: boolean }> {
    return this.http.get<any>(
      `${
        environment.pcmilerAppUrl
      }/api/UserInfo/Exists?email=${encodeURIComponent(value)}`
    );
  }
  signup(requestBody: SignupRequest): Observable<any> {
    return this.http.post<SignupRequest>(
      `${environment.pcmilerAppUrl}api/Signup`,
      requestBody
    );
  }
}
